import { useCheckGPTGameStatus } from '../../../../../api/gpt/useCheckGPTGameStatus';
import { GPT_BUTTONS_CONFIG } from './config';
import { GameLauncherProps } from './types';
import { useGPTGameTrigger } from '../../hooks/useGPTGameTrigger';
import { useGPTBanner } from '../../../banners';
import { useApiContext } from 'react-easyrocket';

export const GPTGameLauncher = ({
  gameName,
  renderButton,
  openRegistration,
  onGameLaunch,
  authOnly = true,
  toShow = false
}: GameLauncherProps) => {
  const { isAvailable } = useCheckGPTGameStatus({ gameName });
  const { Icon, title } = GPT_BUTTONS_CONFIG[gameName];
  const { triggerGPTGame } = useGPTGameTrigger();
  const { isAuthenticated } = useApiContext();
  const hideBanner = useGPTBanner((s) => s.hideBanner);

  if (!isAvailable && !toShow) return null;

  const onClick = () => {
    if (!isAuthenticated && authOnly) {
      openRegistration?.();
      return;
    }
    triggerGPTGame(gameName);
    hideBanner(gameName);
    onGameLaunch?.();
  };

  return renderButton({ Icon, title, onClick });
};
